import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import "./SalesPartyDetails.css";


const options = {
  sortIndicator: true,
  paginationSize: 3,
  clearSearch: true,
  alwaysShowAllBtns: true,
  withFirstAndLast: true,
  searchFieldStyle: { fontSize: "10px", height: "30px" },
};


export default function SalesPartyDetails({ data }) {

  // Custom cell color for paymentStatusColor column
  const paymentStatusColorFormat = (cell, row) => {
    let bgColor = '#e0e0e0';
    if (cell == 'ORANGE') bgColor = '#ffa500';
    else if (cell == 'RED') bgColor = '#ff0000';

    return (
      <div style={{ backgroundColor: bgColor, width: '100%', height: '100%', textAlign: 'center' }}>
        {row.invoiceStatus}
      </div>
    );
  };

  return (
    <div style={{ fontSize: "12px" }}> {/* Reduced overall font size */}
      <BootstrapTable
        data={data}
        version="4"
        condensed={true}
        striped
        hover
        pagination
        search
        options={options}
        exportCSV
        csvFileName="sales_party_summary.csv"
      >
        <TableHeaderColumn
          isKey
          dataField="invoiceNumber"
          export={false}
          hidden={true}
        >
          ID
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="invoiceNumber"
          export={true}
          hidden={false}
        >
          Invoice Number
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="invoiceDate"
          export={true}
          hidden={false}
          dataFormat={(cell) => cell.substring(0, 10)}
        >
          Invoice Date
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="billValue"
          export={true}
          hidden={false}
        >
          Bill Value
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="balance"
          export={true}
          hidden={false}
        >
          Balance
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="paymentType"
          export={true}
          hidden={false}
        >
          Payment Type
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="hulCode"
          export={true}
          hidden={false}
        >
          HUL Code
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="paymentCount"
          export={true}
          hidden={false}
        >
          Payments Count
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="daysToFullPayment"
          export={true}
          hidden={false}
        >
          Days to Full Payment
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="paymentStatusColor"
          export={true}
          hidden={false}
          dataFormat={paymentStatusColorFormat}
        >
          Payment Status color
        </TableHeaderColumn>
        {/* <TableHeaderColumn
          dataField="invoiceStatus"
          export={true}
          hidden={false}
          tdStyle={{ whiteSpace: 'normal' }}
        >
          Invoice Status
        </TableHeaderColumn> */}

      </BootstrapTable>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/CustomComponents/SalesPartyDetails.js